/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ShapeTriangleUpIcon24Regular = forwardRef('ShapeTriangleUpIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.7 4.446c1.085-1.659 3.515-1.659 4.6 0l8.051 12.298c1.198 1.829-.115 4.256-2.3 4.256H3.95c-2.186 0-3.498-2.427-2.301-4.256l8.05-12.298Zm3.346.821a1.25 1.25 0 0 0-2.092 0l-8.05 12.299A1.25 1.25 0 0 0 3.95 19.5h16.1a1.25 1.25 0 0 0 1.046-1.934l-8.05-12.299Z" })));
});
